'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StandardTabPane = _react2['default'].createClass({
    displayName: 'StandardTabPane',

    propTypes: {
        image: _react2['default'].PropTypes.string,
        title: _react2['default'].PropTypes.string.isRequired,
        description: _react2['default'].PropTypes.node.isRequired,
        link: _react2['default'].PropTypes.string,
        linkText: _react2['default'].PropTypes.string,

        // TODO: this prop needs to be required, otherwise React
        // will throw an exception since render() will return undefined (CC)
        paneType: _react2['default'].PropTypes.string,
        bottomImage: _react2['default'].PropTypes.string
    },
    getInitialState: function getInitialState() {
        return { hover: false };
    },

    // TODO: remove these event listeners - should be defined
    // within CSS. See note below (CC)
    onMouseEnter: function onMouseEnter() {
        this.setState({ 'hover': true });
    },
    onMouseLeave: function onMouseLeave() {
        this.setState({ 'hover': false });
    },

    render: function render() {

        var tileLinkButton = null;
        if (this.props.link && this.props.linkText) {
            tileLinkButton = _jsx('div', {
                className: 'l-margin-t-15'
            }, void 0, _jsx(_button2['default'], {
                buttonText: this.props.linkText,
                buttonLink: this.props.link,
                buttonHoverColor: 'cerulean',
                wrapText: true
            }));
        }

        var tileReturnType = _jsx('div', {
            className: 'columns small-8 small-text-center small-centered'
        }, void 0, _jsx('div', {
            className: 'm-tabs_tiles--copy-container'
        }, void 0, _jsx('h4', {
            className: 'm-tabs_tiles--pane-header b'
        }, void 0, this.props.title), _jsx('p', {}, void 0, this.props.description), tileLinkButton));
        var tabReturnType = _jsx('div', {}, void 0, _jsx('div', {
            className: 'show-for-large-up large-6 columns'
        }, void 0, _jsx('img', {
            src: this.props.image,
            className: 'embedded-image'
        })), _jsx('div', {
            className: 'small-12 large-6 small-text-center large-text-left columns'
        }, void 0, _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'small-10 small-centered large-uncentered columns'
        }, void 0, _jsx('h3', {}, void 0, this.props.title))), _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'small-10 small-centered large-uncentered columns'
        }, void 0, _jsx('div', {
            className: 'l-padding-v-20'
        }, void 0, _jsx('p', {}, void 0, this.props.description)))), _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'small-12 columns'
        }, void 0, _jsx(_button2['default'], {
            buttonText: this.props.linkText ? this.props.linkText : 'LEARN MORE',
            buttonLink: this.props.link ? this.props.link : '/api/features',
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        })))));

        if (this.props.paneType == 'tile') {
            return tileReturnType;
        } else if (this.props.paneType == 'tab') {
            return tabReturnType;
        }
    }
});

module.exports = StandardTabPane;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/standard-tab-pane.jsx
 ** module id = 726
 ** module chunks = 0
 **/